import api from 'Application/api/api';

const getProjectDeveloperById = (signal, id, details) =>
	api.get(`/project-developers/by-id/${id}`, {
		params: {
			details,
		},
		signal,
	});

export default getProjectDeveloperById;
